import React, { Suspense, lazy, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';

import useInitUgc from 'ugc/hooks/useInitData/useInitUgc';
import useUgcRoutesProtect from 'ugc/hooks/useInitData/useUgcRoutesProtect';

import Loading from 'client/components/Loading';
import LoadingPromoInit from 'client/components/LoadingPromoInit';
import Ugc from 'ugc/components/Ugc';
import Form from 'ugc/components/form/Form';
import { useReCaptcha } from 'client/hooks/useReCaptcha';
import DialogReCaptcha from 'components/Dialog/DialogReCaptcha';
import useLogout from 'client/hooks/logout/useLogout';

const PrizeContainer = lazy(() =>
    import(/* webpackChunkName: "ugc_prize" */ 'ugc/components/PrizeContainer')
);
const ResultPage = lazy(() =>
    import(/* webpackChunkName: "ugc_result" */ 'ugc/components/result/ResultPage')
);

export default function AppUgc({
    match: {
        params: { promoId: queryPromoId },
        path: matchedPath
    },
    location
}) {
    useUgcRoutesProtect();
    const initUgc = useInitUgc(queryPromoId);
    const { isShowReCaptcha, setShowReCaptcha } = useReCaptcha();

    const { hasInited, hasUserStateInited, hasErrorOnInit } = useSelector(s => s.flags);
    const isIniting = !hasInited && !hasErrorOnInit;
    const isInitingUserState = hasInited && !hasUserStateInited && !hasErrorOnInit;
    const canRenderContent = hasInited || hasErrorOnInit;

    const history = useHistory();
    const logout = useLogout();
    useEffect(() => {
        const parsed = queryString.parse(location.search);
        if (parsed.needLogout === 'true') {
            logout();
            const { needLogout, ...rest } = parsed;
            const newSearch = queryString.stringify(rest);
            history.replace({ search: newSearch });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search, history]);

    if (isIniting) {
        return <LoadingPromoInit />;
    }

    return (
        <>
            {isInitingUserState && <Loading />}
            {canRenderContent && (
                <Suspense fallback={<Loading />}>
                    {isShowReCaptcha && (
                        <DialogReCaptcha onOpen={setShowReCaptcha} onComplete={initUgc} />
                    )}
                    <Switch>
                        <Route path={`${matchedPath}/form`} component={Form} />
                        <Route path={`${matchedPath}/result`} component={ResultPage} />
                        <Route
                            path={`${matchedPath}/prize/:prizeUUID/:entriesUUID`}
                            component={PrizeContainer}
                        />
                        <Route path={`${matchedPath}`} component={Ugc} />
                    </Switch>
                </Suspense>
            )}
        </>
    );
}
